import { DownloadSVG } from 'common/assets';
import Button, { ButtonProps } from 'components/elements/buttons/button';
import useJsonToExcel, { UseJsonToExcelProps } from 'hooks/use-json-to-excel';
import useTranslation from 'next-translate/useTranslation';

interface ExportToExcelProps<T> extends UseJsonToExcelProps<T> {
  buttonProps?: ButtonProps;
}

export default function ExportToExcel<T>(props: ExportToExcelProps<T>) {
  const { data, buttonProps, filename = 'data' } = props;
  const onExport = useJsonToExcel({
    data,
    filename,
  });

  const { t } = useTranslation();

  return (
    <Button
      style={{ width: 180 }}
      startEnhancer={(color, size) => <DownloadSVG color={color} size={size} />}
      onClick={onExport}
      {...buttonProps}
    >
      {t('common:export_to_excel')}
    </Button>
  );
}
